const WEAPON_LEVEL_MATERIAL_MAP = {
  ENHANCEMENT_ORE_1: 'enhancement_ore',
  ENHANCEMENT_ORE_2: 'fine_enhancement_ore',
  ENHANCEMENT_ORE_3: 'mystic_enhancement_ore',
}

export default WEAPON_LEVEL_MATERIAL_MAP;
